import secureLocalStorage from "react-secure-storage";
import { stdObject } from "../data/types/stdObject";

export const saveActiveDoc = (id: number, data: stdObject) => {
  const raw = secureLocalStorage.getItem("tempDocs");
  let docsList: stdObject = typeof raw === "object" && raw !== null ? raw : {};

  const userKey = id.toString();
  if (!(userKey in docsList) && userKey !== "undefined") {
    docsList = {
      ...docsList,
      [userKey]: {},
    };
  }
  docsList[userKey][data.id] = data;
  secureLocalStorage.setItem("tempDocs", docsList);
};

export const removeActiveDoc = (id: number, key: string) => {
  const raw = secureLocalStorage.getItem("tempDocs");
  let docsList: stdObject = typeof raw === "object" && raw !== null ? raw : {};
  if (id.toString() in docsList && key in docsList[id.toString()]) {
    delete docsList[id.toString()][key];
    if (Object.keys(docsList[id.toString()]).includes("undefined")) {
      delete docsList[id.toString()]["undefined"];
    }
    secureLocalStorage.setItem("tempDocs", docsList);
    return Object.keys(docsList[id.toString()]).length;
  }
  return 0;
};

export const checkActiveDoc = (id: number, data: stdObject) => {
  const raw = secureLocalStorage.getItem("tempDocs");
  let docsList: stdObject = typeof raw === "object" && raw !== null ? raw : {};

  const userKey = id.toString();
  if (userKey in docsList) {
    const userList = (docsList[userKey] as stdObject) ?? {};
    const existingData = Object.values(userList).find((v: stdObject) => {
      if (!v || typeof v !== "object" || v.type !== data.type) return false;
      return (
        v.data?.[`SER${v.type}`] === data.serie &&
        v.data?.[`COD${v.type}`] === data.code
      );
    });

    if (existingData) {
      return existingData;
    }
  }
  return null;
};
